import { MeteringPoint } from '~/data';

const getMeteringPointPath = (meteringPoint: Pick<MeteringPoint, 'meteringPointId'>): string => {
  return `/metering-points/${meteringPoint.meteringPointId}`;
};

export default getMeteringPointPath;
